import ChannelLabel from '@op/components/ChannelLabel';
import React from 'react';

export default function ChannelAccountItem({
  isBlock = false,
  item,
}: {
  isBlock?: boolean;
  item: { channel: string; text?: string; account?: string };
}) {
  return (
    <ChannelLabel
      className={`dbo-channel-account-item ${isBlock ? '--dbo-block' : ''}`}
      channel_name={item.channel as any}
      replaceText={item.text || item.account}
      iconStyle={{ width: 16, height: 16 }}
    />
  );
}
